import { z } from 'zod'
import { TRAINER_CONTRACT_VERSION } from './trainer-event-read'

/** Storage/upload signed-URL and long-poll contracts stay intentionally loose: handlers keep exact validation order and status branching. */
const storageObject = z.object({
  contract_version: z.literal(TRAINER_CONTRACT_VERSION),
}).passthrough()


export const trainerInvoiceDownloadResponseSchema = storageObject
export type TrainerInvoiceDownloadResponse = z.infer<typeof trainerInvoiceDownloadResponseSchema>

export const trainerInvoicePdfGenerationResponseSchema = storageObject
export type TrainerInvoicePdfGenerationResponse = z.infer<typeof trainerInvoicePdfGenerationResponseSchema>

export const trainerInvoiceUploadCompleteResponseSchema = storageObject
export type TrainerInvoiceUploadCompleteResponse = z.infer<typeof trainerInvoiceUploadCompleteResponseSchema>

export const trainerInvoiceUploadSignedDownloadResponseSchema = storageObject
export type TrainerInvoiceUploadSignedDownloadResponse = z.infer<typeof trainerInvoiceUploadSignedDownloadResponseSchema>
